import React, { forwardRef } from 'react';
import {
  Input as ChakraInput,
  InputProps,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends InputProps {
  variant?: `withIcon`;
  name?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ name, variant, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Input`, { variant });
    return (
      <ChakraInput id={name} name={name} ref={ref} __css={styles} {...props} />
    );
  }
);
export type { Props as InputProps };
